import StubPage from '../../components/StubPage.jsx';

export default function SecurityPage() {
  return (
    <StubPage
      title="Security"
      description="Authentication, encryption, access control, and compliance."
      planned={[
        'SSO + 2FA for workspace members',
        'Role-based permissions per workspace and per site',
        'GDPR-ready data export + deletion flows',
        'DDoS protection at the edge',
        'Audit log of every workspace mutation',
      ]}
    />
  );
}
